import React from 'react';
import { CheckCircle, Clock, Zap, Shield, TrendingUp, Users } from 'lucide-react';

const WhyUs = () => {
  const benefits = [
    {
      icon: <Zap className="w-10 h-10 text-[#FFD700]" />,
      title: 'Быстрое внедрение',
      description: 'Запускаем проекты от одной недели. Минимум бюрократии, максимум эффективности.'
    },
    {
      icon: <TrendingUp className="w-10 h-10 text-[#FFD700]" />,
      title: 'Рост продаж в 3 раза',
      description: 'Наши клиенты увеличивают конверсию в среднем на 200-300% за первые 2 месяца.'
    },
    {
      icon: <Clock className="w-10 h-10 text-[#FFD700]" />,
      title: 'Экономия времени',
      description: 'Бот обрабатывает 90% запросов. Вы фокусируетесь только на важных задачах.'
    },
    {
      icon: <Users className="w-10 h-10 text-[#FFD700]" />,
      title: 'Не нужны новые сотрудники',
      description: 'Один бот заменяет команду менеджеров. Никаких зарплат, отпусков и больничных.'
    },
    {
      icon: <Shield className="w-10 h-10 text-[#FFD700]" />,
      title: 'Гарантия качества',
      description: 'Техподдержка и доработки в течение гарантийного периода.'
    },
    {
      icon: <CheckCircle className="w-10 h-10 text-[#FFD700]" />,
      title: 'Полная настройка',
      description: 'Обучаем бота на ваших данных, настраиваем под ваш бизнес и интегрируем.'
    }
  ];

  return (
    <section id="why-us" className="py-16 sm:py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Почему выбирают нас
          </h2>
          <p className="text-lg sm:text-xl text-gray-600 max-w-3xl mx-auto">
            Мы делаем так, чтобы ваш бизнес работал на автопилоте
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <div 
              key={index} 
              className="group p-6 sm:p-8 bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100 hover:border-blue-200"
            >
              <div className="mb-4 transform group-hover:scale-110 transition-transform duration-300">
                {benefit.icon}
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {benefit.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyUs;
